import { ApiClient } from '@/services/http/apiClient';
import type { Coupon, CouponValidationRequest, CouponValidationResponse, CouponStats } from '@/types/api';

export const CouponService = {
  // Público: valida desconto
  async validate(code: string, order_total_cents: number): Promise<CouponValidationResponse> {
    const body: CouponValidationRequest = { code, order_total_cents };
    return ApiClient.post<CouponValidationResponse>('/coupons/validate', { body });
  },

  // Admin
  admin: {
    async list(): Promise<Coupon[]> {
      return ApiClient.get<Coupon[]>('/admin/coupons');
    },
    async show(id: number): Promise<Coupon> {
      return ApiClient.get<Coupon>(`/admin/coupons/${id}`);
    },
    async create(data: Partial<Coupon> & { code: string; type: 'percent' | 'fixed'; value: number }) {
      return ApiClient.post<Coupon>('/admin/coupons', { body: data });
    },
    async update(id: number, data: Partial<Coupon>) {
      return ApiClient.put<Coupon>(`/admin/coupons/${id}`, { body: data });
    },
    async delete(id: number) {
      return ApiClient.delete<{ success: boolean; message?: string }>(`/admin/coupons/${id}`);
    },
    async toggleActive(id: number) {
      return ApiClient.patch<Coupon>(`/admin/coupons/${id}/toggle-active`);
    },
    async toggleStatus(id: number) { // alias
      return ApiClient.patch<Coupon>(`/admin/coupons/${id}/toggle-status`);
    },
    async stats(id: number): Promise<CouponStats> {
      return ApiClient.get<CouponStats>(`/admin/coupons/${id}/stats`);
    },
    async statistics(): Promise<{ total: number; active: number; used: number }> {
      return ApiClient.get<{ total: number; active: number; used: number }>(`/admin/coupons/statistics`);
    },
  },
};